import { WarningLevel } from 'editor/src/store/editorModules/warnings/types';
import { RootState } from 'editor/src/store/index';

import getVisibleWarnings from './getVisibleWarnings';

const getHighWarningsCount = (state: RootState) =>
  getVisibleWarnings(state).reduce((count, warning) => count + (warning.level === WarningLevel.High ? 1 : 0), 0);

export default getHighWarningsCount;
